import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import { ChangeHistory } from '@/common/components/ChangeHistory'
import useModalMessagesSimple from '@/common/hooks/useModalMessagesSimple'
import { ErrorResponse } from '@/common/types/errorResponse'
import { LeadHeader } from '@/features/publicCompanyLeadsFunnel/components/LeadHeader'
import { ResponsibleSection } from '@/features/publicCompanyLeadsFunnel/components/ResponsibleSection'
import { useAdvancePublicCompanyLead } from '@/features/publicCompanyLeadsFunnel/hooks/useAdvancePublicCompanyLead'
import usePublicCompanyLeadForm from '@/features/publicCompanyLeadsFunnel/hooks/usePublicCompanyLeadForm'
import { PublicCompanyLeadData } from '@/features/publicCompanyLeadsFunnel/types/publicCompanyLead'
import { useQueryClient } from '@tanstack/react-query'
import { FormProvider } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

const LeadRegisteredForm = ({ id, publicCompanyLead }: { id: string; publicCompanyLead: PublicCompanyLeadData }) => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const { setMessages } = useModalMessagesSimple({
    isError: true,
  });

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['publicCompanyLead', id] })
    navigate('/public-clients')
  }

  const onError = (error: ErrorResponse) => {
    setMessages(error, { errorResponse: true });
  }

  const { mutate: advancePublicCompanyLead, isPending: advancePublicCompanyLeadIsPending } =
    useAdvancePublicCompanyLead({ id, onSuccess, onError })

  const useFormMethods = usePublicCompanyLeadForm({ publicCompanyLead })

  return (
    <FormProvider {...useFormMethods}>
      <form>
        <LeadHeader
          publicCompanyLeadId={id}
          display_name={publicCompanyLead.display_name}
          url={publicCompanyLead.general_information?.company_logo?.url}
          showArchiveButton
          archived_at={publicCompanyLead.archived_at}
          buttons={
            <Button
              type="button"
              data-testid="initial_qualifying_button"
              className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]"
              variant="default"
              onClick={() => advancePublicCompanyLead()}
              isLoading={advancePublicCompanyLeadIsPending}
            >
              Iniciar Qualificação
            </Button>
          }
        />
        <div className="flex gap-6">
          <Box className="w-full flex flex-col gap-6 max-h-[calc(100vh-130px)] overflow-y-auto shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
            <ResponsibleSection publicCompanyLead={publicCompanyLead} disabled />
          </Box>
          <ChangeHistory logs={publicCompanyLead?.logs || []} entityId={id} bodyClassName="max-h-[calc(100vh-186px)]" />
        </div>
      </form>
    </FormProvider>
  )
}

export default LeadRegisteredForm
